// extracted by mini-css-extract-plugin
export default {"row":"FooterRow_row__3JtHN"};